<template>
  <div class="register-wrap">
    <referer-site-info @updateSiteInfo="updateSiteInfo" />
    <authLeft  v-if="$mq != 'sp' && $mq != 'tb'"/>
    <div class="register-right">
      <div class="register-form">
      <div class="data-table-list-nolist">
        <img src="../../assets/bug_fixed.png" style="opacity:0.5" alt />
        <div style="font-size:20px; font-weight:700; margin-bottom:10px;" v-if="$mq!='sp'">ご利用中のブラウザは動作を保証しておりません。</div>
        <div style="font-size:20px; font-weight:700; margin-bottom:10px;" v-else>{{ siteName }} はスマートフォンではご利用いただけません</div>
        <div style="margin-bottom: 30px;" v-if="$mq!='sp'">
          <a class="pointer" href="https://www.google.co.jp/chrome/" style="color:#aaa; border-bottom:1px solid #aaa" target="_blank">Chromeブラウザ</a>をダウンロードしてご利用ください。
        </div>
        <div style="margin-bottom: 30px;" v-else>
          PCのChromeブラウザでご利用ください。
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import authLeft from "./auth_left";
import RefererSiteInfo from "@/components/oem/RefererSiteInfo";

export default {
  name: "incompatible",
  components: {
    authLeft,
    RefererSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      siteName: "REECH DATABASE",
    };
  },
  mounted() {},
  methods: {
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  }
};
</script>